import React from 'react';
import styled from 'styled-components';
import PingLogo from '../Header/PingLogo';
import CorePassLogo from './CorePassLogo';

const FooterContainer = styled.footer`
  background: rgba(15, 15, 35, 0.95);
  border-top: 1px solid #2d2d5f;
  padding: 2rem 0;
  margin-top: auto;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: center;
  text-align: center;
`;

const PoweredBySection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
`;

const PoweredByText = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.875rem;
  color: #a0a0a0;
  font-weight: 500;
`;

const Copyright = styled.div`
  font-size: 0.75rem;
  color: #666;
  text-align: center;
`;

const LinksSection = styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
`;

const FooterLink = styled.a`
  color: #a0a0a0;
  text-decoration: none;
  font-size: 0.875rem;
  transition: color 0.3s ease;

  &:hover {
    color: #3d4de6;
  }
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterContent>
        <PoweredBySection>
          <PoweredByText>
            <span>Powered by</span>
            <PingLogo />
            <span>&</span>
            <CorePassLogo />
          </PoweredByText>
        </PoweredBySection>

        <LinksSection>
          <FooterLink href="/terms">Terms of Service</FooterLink>
          <FooterLink href="/privacy">Privacy Policy</FooterLink>
          <FooterLink href="/support">Support</FooterLink>
          <FooterLink href="/api-docs">API Documentation</FooterLink>
        </LinksSection>

        <Copyright>
          © {currentYear} Ping Digital Commodities Exchange. All rights reserved.
        </Copyright>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer; 